export default __webpack_public_path__ + "static/media/mp3.4dfa7755.svg";